import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ItdoseService {

  constructor(private http: HttpClient) { }

  //To get the cities for IT Dose 
  getCitiesForITDose() {
    return this.http.get(`${environment.apiUrl}ITDose/GetAllCities`);
  }

  //To get the area and pincode
  getAreasOnCity(StateId, CityId) {
    return this.http.get(`${environment.apiUrl}ITDose/GetAreasOnCity?StateId=${StateId}&CityId=${CityId}`);
  }

  //To get the slots for IT Dose 
  getAvailableSlots(payload) {
    return this.http.post(`${environment.apiUrl}ITDose/GetAvailableSlots`, payload);
  }

  //To get the google locations for IT Dose
  getGoogleLocations(search) {
    return this.http.get(`${environment.apiUrl}ITDose/GetGooglePredictions?query=${search}`);
  }

  //To get the packages for IT Dose
  getPackages(StateId, CityId) {
    return this.http.get(`${environment.apiUrl}ITDose/GetPackages?StateId=${StateId}&CityId=${CityId}`);
  }

  //To get the Geo code details for IT Dose
  getGeoCodeDetails(address) {
    return this.http.get(`${environment.apiUrl}ITDose/GetGeoCodeDetails?address=${address}`);
  }

  //Check area serviceability for IT Dose
  CheckAreaServiceability(payload) {
    return this.http.post(`${environment.apiUrl}ITDose/CheckAreaServiceability`, payload);
  }

  //To get the salutation for IT Dose 
  getTitles() {
    return this.http.get(`${environment.apiUrl}ITDose/GetTitle`);
  }

  //To get the gender for IT Dose 
  getGender() {
    return this.http.get(`${environment.apiUrl}ITDose/GetGender`);
  }

  //Book appointment for diagnostics
  BookAppointmentForDiagnostics(payload) {
    return this.http.post(`${environment.apiUrl}ITDose/BookAppointment`, payload);
  }

  //Get Appointment Booking History
  getAppointmentBookingHistory(uhid,mobileNumber) {
    return this.http.get(`${environment.apiUrl}ITDose/BookingHistory?uhid=${uhid}&mobileNumber=${mobileNumber}`);
  }

  //Get Booking Status On Pre-booking Id
  getBookingStatusOnPreBookingId(preBookingId) {
    return this.http.get(`${environment.apiUrl}ITDose/BookingStatus?preBookingId=${preBookingId}`);
  }

  //Reschedule Diagnostic Appointment in IT Dose
  RescheduleDiagnosticAppointment(payload) {
    return this.http.post(`${environment.apiUrl}ITDose/RescheduleAppointment`, payload);
  }

  //Cancel Diagnostic Appointment in IT Dose
  CancelDiagnosticAppointment(payload) {
    return this.http.post(`${environment.apiUrl}ITDose/CancelAppointment`, payload);
  }

}
